let config: AppConfigTree | null = null;

export type AppConfigGetter<TValue> = (config: AppConfigTree) => TValue;

export function optAppConfig<TValue>(
  getter: AppConfigGetter<TValue>,
  defaultValue?: TValue,
): TValue | null {
  if (typeof window === 'undefined') {
    // NOTE: This is currently browser only. We could add a server-side implementation
    //       if needed, using something similar to UNIT_TEST__setAppConfig().
    throw new Error('getConfig() must be called in the browser');
  }
  if (!config) {
    // Parse config from the meta tag
    const name = 'app-config';
    const meta = window.document.querySelector(`meta[name="${name}"]`);
    const encodedConfig = meta?.getAttribute('content') ?? 'bnVsbA=='; // "null"
    const decodedConfig = JSON.parse(window.atob(encodedConfig));
    config = decodedConfig as AppConfigTree;
    if (decodedConfig?.__log) {
      console.log('Config:', config);
    }
  }
  try {
    const value = getter(config) ?? defaultValue ?? null;
    return value;
  } catch (e) {
    return defaultValue ?? null;
  }
}

export function getAppConfig<TValue>(
  getter: AppConfigGetter<TValue>,
  defaultValue?: TValue,
): TValue {
  const value = optAppConfig(getter, defaultValue);
  if (value === null) {
    throw new Error(`getConfig() failed to get the value for "${getter}"`);
  }
  return value;
}

// This function overrides the config object, for unit tests ONLY!
// eslint-disable-next-line camelcase
export function UNIT_TEST__setAppConfig(newConfig: AppConfigTree) {
  config = newConfig;
}
